import React, { useState } from "react";
import { Wallet, Receipt, Truck, Package, FileMinus } from "lucide-react";
import { COLORS } from "./ui";
import { ResellerBalancePanel } from "./ResellerBalancePanel";
import { ResellerInvoices, ResellerDeliveryNotes, ResellerOrders, ResellerCreditNotes } from "./ResellerDocLists";

const SECTIONS = [
  { key: "solde", label: "Solde & relevé", icon: Wallet, Comp: ResellerBalancePanel },
  { key: "factures", label: "Factures", icon: Receipt, Comp: ResellerInvoices },
  { key: "bl", label: "Bons de livraison", icon: Truck, Comp: ResellerDeliveryNotes },
  { key: "commandes", label: "Commandes", icon: Package, Comp: ResellerOrders },
  { key: "avoirs", label: "Avoirs", icon: FileMinus, Comp: ResellerCreditNotes },
];

export const ResellerSpace = ({ resellerName }) => {
  const [active, setActive] = useState("solde");
  const { Comp } = SECTIONS.find((s) => s.key === active);
  return (
    <div data-testid="tab-content-pro">
      <p className="text-xs mb-4" style={{ color: COLORS.secondary }}>
        Documents de <span style={{ color: COLORS.primary }}>{resellerName}</span>, partagés entre tous les comptes de votre établissement.
      </p>
      <div className="flex gap-2 flex-wrap mb-5" data-testid="pro-subtabs">
        {SECTIONS.map(({ key, label, icon: Icon }) => {
          const on = key === active;
          return (
            <button
              key={key}
              type="button"
              onClick={() => setActive(key)}
              className="inline-flex items-center gap-1.5 px-3 py-2 text-[11px] uppercase tracking-[0.18em] transition-colors"
              style={{ color: on ? COLORS.bg : COLORS.secondary, background: on ? COLORS.gold : "transparent", border: `1px solid ${on ? COLORS.gold : "rgba(242,236,228,0.15)"}` }}
              data-testid={`pro-subtab-${key}`}
            >
              <Icon className="w-3.5 h-3.5" /> {label}
            </button>
          );
        })}
      </div>
      <Comp />
    </div>
  );
};

export default ResellerSpace;
